import { env } from "./env";

export const urls = {
  productImage: (productCode: string, merchantId: number, size: "small" | "original") => {
    return `${env.VITE_IMAGE_BASE_URL}/merchants/${merchantId}/product-images${
      size === "small" ? "/100x100" : ""
    }/${encodeURIComponent(productCode)}.jpg`;
  },
};
